"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Highcharts = __importStar(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledContainer = styled_components_1.default.div `
  width: 152px;
  height: 92px;
  .highcharts-background {
    fill: transparent;
  }
`;
const ConfidenceNumberGaugeDesktop = (props) => {
    let crosshairLine, chartRenderer, cn;
    const options = {
        chart: {
            plotBackgroundColor: "transparent",
            plotBorderWidth: 0,
            plotShadow: false,
            height: 168,
            width: 152,
            events: {
                render: function () {
                    chartRenderer = this.renderer;
                    const title = this.title;
                    if (props.confidenceNumber !== null && props.confidenceNumber !== undefined) {
                        cn = parseInt(title.textStr);
                        if (crosshairLine) {
                            crosshairLine.destroy();
                        }
                        const arcStartAngle = ((100 - cn) * Math.PI) / 100;
                        if (chartRenderer) {
                            crosshairLine = chartRenderer
                                .arc(76, 84, 78, 52, -arcStartAngle, -(arcStartAngle + 0.001))
                                .attr({
                                stroke: props.markerColor || tokens.ColorWhite000,
                                "stroke-width": 3,
                                zIndex: 6
                            })
                                .add();
                        }
                    }
                }
            }
        },
        title: {
            text: props.confidenceNumber === null || props.confidenceNumber === undefined ? '?' : props.confidenceNumber + "%",
            align: "center",
            verticalAlign: "middle",
            y: props.desktopTitleY !== null && props.desktopTitleY !== undefined ? props.desktopTitleY : 12,
            style: {
                fontFamily: "Nimbus Sans Bold",
                fontSize: props.desktopFontSize || "34px",
                color: props.fontColor || tokens.ColorWhite000,
                letterSpacing: "-1px"
            }
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false
                },
                startAngle: -90,
                endAngle: 90,
                center: ["50%", "50%"],
                size: 144,
                borderWidth: 0,
                opacity: props.hasError ? 0.2 : 1,
                colors: [
                    tokens.ColorFunctionalOrange300,
                    tokens.ColorFunctionalGold300,
                    tokens.ColorFunctionalGreen300
                ],
                animation: {
                    duration: 1000
                }
            }
        },
        series: [
            {
                type: "pie",
                innerSize: "75%",
                enableMouseTracking: false,
                data: [69, 10, 21]
            }
        ]
    };
    return (React.createElement(StyledContainer, null,
        React.createElement(highcharts_react_official_1.default, Object.assign({ highcharts: Highcharts, options: options }, props))));
};
exports.default = ConfidenceNumberGaugeDesktop;
//# sourceMappingURL=ConfidenceNumberGaugeDesktop.js.map